module.exports = __webpack_public_path__ + "media/components/lesson2/statics/serverConnectionError-6767ae4c29ed7dc653415e51432fec36.png";